<template>
    <div class="vue-review-block-small klantenvertellen-block-small">
        <div class="grade" v-if="hasRating">
          <a :href="viewLink" target="_blank">
            {{ score }}
          </a>
        </div>
    </div>
</template>

<script>
    import {klantenvertellenOptions} from "../mixins/klantenvertellen";

    export default {
        name: "ReviewBlockSmall",

        mixins: [klantenvertellenOptions]
    }
</script>
